import React, {Component} from 'react';
import classNames from 'classnames';
import {Link} from 'gatsby';
import IconArrowHero from './IconArrowHero';
import Reveal from './Reveal';
import {connectToStore} from './Provider';

class HomeHeroNewsletter extends Component {
	constructor() {
		super();
		this.state = {email: ''};
	}

	onSubmit = event => {
		event.preventDefault();
		
		this.props.openNewsletterModal(this.state.email);
	}

	render() {
		const {
			mobileBackgroundImage,
			backgroundImage,
			title,
			categoryLinks,
		} = this.props;

		const {
			email
		} = this.state;

		const bgImage = (
			<div className="image--cover hero__bg--newsletter">
				<picture>
					<source
						srcSet={`${backgroundImage}?w=2560&auto=format`}
						media="(min-width: 1400px)"
					/>
					<source
						srcSet={`${backgroundImage}?w=1600&auto=format`}
						media="(min-width: 800px)"
					/>
					<img
						alt={title}
						src={`${mobileBackgroundImage}?w=800&auto=format`}
					/>
				</picture>
			</div>
		);

		const categoryColumns = categoryLinks.map((link, index) => (
			<div
				key={link._key}
				className={classNames('col c4--md reveal__slide reveal__slide--medium', `reveal__delay--${index + 5}`)}>
				<Link
					title={link.title}
					to={link.url}
					className={classNames('hero__col--newsletter db pt4 pl2 pr2 pb4 pb5--md tc link--hover--target', {
						'no-border': index === 0
					})}>
					<img
						alt={link.title}
						src={link.icon}
						className="db m--auto mb2"
					/>
					<span className="db sans--small uppercase fw--600 mb1">
						{link.title}
					</span>
					<span className="db sans--small fw--500 color--gray-border mb2">
						{link.description}
					</span>
					<span className="db">
						<span className="db m--auto button--hero">
							<IconArrowHero />
						</span>
					</span>
				</Link>
			</div>
		));
		
		return (
			<Reveal>
				<div className="pr bg--black color--white">
					{bgImage}
					<div className="push-up">
						<div className="grid-container contained pt12">
							<div className="row pt12 pt8--md pb10--md">
								<div className="col c8--md c6--xl">
									<h1 className="domaine--large mb3 mb6--md text-shadow tc tl--md reveal__slide reveal__slide--medium reveal__delay--3">
										{title}
									</h1>
									<div className="reveal__slide reveal__slide--medium reveal__delay--5">
										<h2 className="sans--small uppercase fw--600 mb2">
											Sign Up Today
										</h2>
										<form
											onSubmit={this.onSubmit}
											className="pr hero__input">
											<input
												value={email}
												onChange={event => this.setState({email: event.target.value})}
												name="email"
												className="full-width input--newsletter-invert"
												placeholder="Enter Your Email Address"
											/>
											<button
												title="Submit"
												className="db input--newsletter__submit"
												type="submit"
												name="submit">
												<img
													alt="Submit"
													className="full-width"
													src="/images/icon-arrow-newsletter-invert.svg"
												/>
											</button>
										</form>
									</div>
								</div>
							</div>
							<div className="hero__footer--newsletter pr pt10--sm">
								<div className="hero__footer--newsletter--inner">
									<div className="row">
										{categoryColumns}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Reveal>
		);
	}
}

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openNewsletterModal,
}) => ({
	openNewsletterModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(HomeHeroNewsletter);